/* eslint-disable react-hooks/exhaustive-deps */
import { message } from "antd";
import { useEffect } from "react";
import ActionModal from "../../../../../components/ui/ActionModal";
import { useReopenTicketMutation } from "../../../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../../../hooks/useError";
import { ModalComponentProps } from "../../../../../types";

type ForwardTicketModalProps = ModalComponentProps & {
  id?: number | string;
};

export default function ReopenTicketModal({
  handleClose,
  id,
  ...rest
}: ForwardTicketModalProps) {
  const [reopen, { isLoading, isError, error, isSuccess }] =
    useReopenTicketMutation();

  const handleReopenTicket = () => {
    reopen({ id });
  };

  useError(isError, error, "Ticket Re-Open Failed.");

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      message.success("Ticket Successfully Re-Opened.");
    }
  }, [isSuccess]);
  return (
    <>
      <ActionModal
        {...rest}
        loading={isLoading}
        title={"Do you want to re-open this ticket?"}
        subTitle="Are you sure you want to re-open this ticket? This action cannot be undone."
        iconType="warning"
        cancelButton={false}
        actionBtnText={`Yes, Re-Open`}
        actionBtnIcon
        actionBtnIconType="refresh"
        handleClose={handleClose}
        handleAction={handleReopenTicket}
        handleCancel={handleClose}
      />
    </>
  );
}
